import { k as getSDLHeaderSelector } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { C as asyncComponentOnReady } from './utils-15ad90ec.js';

const BANNER_STYLES_BY_CONTEXT = {
  body: 'position:fixed;top:0;width:100%;z-index:2000',
  header: 'position:absolute;width:100%;top:100%;z-index:2000',
};

const getContainer = (target) => {
  let container;
  if (target === 'header') {
    container = document.querySelector(getSDLHeaderSelector());
  }
  if (!container) {
    container = document.body;
  }
  return container;
};
const getStyles = (target) => {
  return { style: BANNER_STYLES_BY_CONTEXT[target] };
};

class NotificationBannerController {
  constructor(duration) {
    this.duration = duration;
    this.timeoutId = null;
    this.handleDidClose = (event) => {
      const target = event.target;
      target.remove();
      this.bannerElement = null;
      this.killTimeout();
    };
    this.handleCloseClick = (event) => {
      event.target.active = false;
    };
  }
  startTimeout() {
    if (!this.duration) {
      return;
    }
    this.timeoutId = window.setTimeout(() => {
      if (this.bannerElement) {
        this.bannerElement.active = false;
      }
    }, this.duration);
  }
  killTimeout() {
    if (!this.timeoutId) {
      return;
    }
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
  getBannerElement() {
    return this.bannerElement;
  }
  async show(opts) {
    if (this.bannerElement) {
      return this.showAfter(this.bannerElement, opts);
    }
    if (this.createPromise) {
      return this.showAfter(await this.createPromise, opts);
    }
    this.createPromise = this.create(opts);
    this.bannerElement = await this.createPromise;
    this.createPromise = null;
    return this.bannerElement;
  }
  async showAfter(element, opts) {
    await this.close(element);
    return this.show(opts);
  }
  async close(element) {
    element.active = false;
    return new Promise((resolve) => {
      element.addEventListener('didClose', resolve);
    });
  }
  async create({ target = 'header', componentProps }) {
    const element = document.createElement('pes-notification-banner');
    element.dir = document.documentElement.dir || 'auto';
    const container = getContainer(target);
    container.appendChild(element);
    const fixTarget = container === document.body ? 'body' : target;
    Object.assign(element, getStyles(fixTarget), componentProps);
    element.addEventListener('closeDidClick', this.handleCloseClick);
    element.addEventListener('didClose', this.handleDidClose);
    this.bannerElement = await asyncComponentOnReady(element);
    this.startTimeout();
    return this.bannerElement;
  }
}

export { NotificationBannerController as N };
